export default __webpack_public_path__ + "static/media/icon_un_view.430e4fa2.svg";